<template>
  <path pid="0" d="M20.54 12.16l-14-9A1 1 0 005 4v18a1 1 0 001.54.84l14-9a1 1 0 000-1.68zM7 20.17V5.83L18.15 13z"/>
</template>
